var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditBottomTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4055_8270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 19.0726H7.33318C6.96517 19.0726 6.6665 18.7739 6.6665 18.4059C6.6665 18.0379 6.96517 17.7393 7.33318 17.7393H19.3333C19.7013 17.7393 20 18.0379 20 18.4059C20 18.7739 19.7013 19.0726 19.3333 19.0726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666489 19.0726C0.491357 19.0726 0.321596 19.0042 0.195293 18.8771C0.031717 18.7135 -0.0348527 18.478 0.0175567 18.2531L0.98648 14.1419C1.01496 14.0211 1.07616 13.9108 1.16422 13.8237L13.4212 1.56672C14.1751 0.81199 15.4941 0.810199 16.2497 1.56672L17.5067 2.82357C17.8844 3.20134 18.0925 3.70362 18.0925 4.23781C18.0925 4.77216 17.8844 5.27525 17.5067 5.65205L5.24955 17.9082C5.16165 17.9963 5.0513 18.0576 4.93135 18.0859L0.820137 19.0549C0.768704 19.0674 0.717108 19.0726 0.666489 19.0726ZM2.24073 14.6318L1.5625 17.5099L4.44078 16.8317L16.5635 4.709C16.6898 4.5827 16.7591 4.41571 16.7591 4.23781C16.7591 4.06007 16.6898 3.8921 16.5635 3.76677L15.3066 2.50895C15.055 2.25732 14.615 2.25732 14.3644 2.50895L2.24073 14.6318ZM4.77754 17.4372H4.78649H4.77754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3457 8.53581C14.1752 8.53581 14.0044 8.47087 13.8747 8.34017L10.7314 5.19707C10.471 4.93665 10.471 4.51445 10.7314 4.25403C10.992 3.99345 11.4142 3.99345 11.6747 4.25403L14.8178 7.39713C15.0782 7.65755 15.0782 8.07975 14.8178 8.34017C14.6871 8.47087 14.5165 8.53581 14.3457 8.53581Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4055_8270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditBottomTable);
export default __webpack_public_path__ + "static/media/icon-edit-bottom-table.1871b73365868cfb610e6ddd5bff37d1.svg";
export { ForwardRef as ReactComponent };